/* Thumbnail gallery for the DRGNFLY featured product section. */
if (!customElements.get('drgnfly-gallery')) {
  customElements.define(
    'drgnfly-gallery',
    class DrgnflyGallery extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => this.show(index));
        });
      }

      show(index) {
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
        this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
      }
    }
  );
}
